var map = {
	"./hero/style.scss": "./blocks/hero/style.scss",
	"./issues-list/style.scss": "./blocks/issues-list/style.scss",
	"./logo-slider/style.scss": "./blocks/logo-slider/style.scss",
	"./post-slider/style.scss": "./blocks/post-slider/style.scss",
	"./testimonial-slider/style.scss": "./blocks/testimonial-slider/style.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive style\\.scss$";